export default function IosTimeOutline() {
  return (
    <div
      className="ion-icon-ios-time-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<g>
		<path class="st0" d="M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224
			C480,132.3,379.7,32,256,32z M403.1,403.1c-19.1,19.1-41.4,34.1-66.1,44.6c-25.6,10.8-52.9,16.3-81,16.3c-28.1,0-55.3-5.5-81-16.3
			c-24.8-10.5-47-25.5-66.1-44.6C89.8,384,74.8,361.7,64.3,337C53.5,311.3,48,284.1,48,256c0-28.1,5.5-55.3,16.3-81
			c10.5-24.8,25.5-47,44.6-66.1C128,89.8,150.3,74.8,175,64.3C200.7,53.5,227.9,48,256,48c28.1,0,55.3,5.5,81,16.3
			c24.8,10.5,47,25.5,66.1,44.6c19.1,19.1,34.1,41.4,44.6,66.1c10.8,25.6,16.3,52.9,16.3,81c0,28.1-5.5,55.3-16.3,81
			C437.2,361.7,422.2,384,403.1,403.1z"/>
		<circle class="st0" cx="256" cy="80" r="8"/>
		<circle class="st0" cx="256" cy="432" r="8"/>
		<circle class="st0" cx="432" cy="256" r="8"/>
		<circle class="st0" cx="80" cy="256" r="8"/>
		<circle class="st0" cx="168" cy="103.6" r="8"/>
		<circle class="st0" cx="344" cy="408.4" r="8"/>
		<circle class="st0" cx="408.4" cy="168" r="8"/>
		<circle class="st0" cx="103.6" cy="344" r="8"/>
		<circle class="st0" cx="103.6" cy="168" r="8"/>
		<circle class="st0" cx="408.4" cy="344" r="8"/>
		<circle class="st0" cx="344" cy="103.6" r="8"/>
		<circle class="st0" cx="168" cy="408.4" r="8"/>
	</g>
	<path class="st0" d="M269.9,248c-2.9-5-8.1-7.8-13.4-8l-38-63.4c-2.3-3.8-7.2-5-11-2.7c-3.8,2.3-5,7.2-2.7,11l37.6,62.9
		c-2.9,4.8-3.2,11.1-0.2,16.3c1.5,2.5,3.5,4.5,5.9,5.8V392c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8V269.9
		C271.7,265.4,274.3,255.7,269.9,248z"/>
</g>
</svg>
`,
      }}
    />
  )
}
